// extracted by mini-css-extract-plugin
module.exports = {"divider":"AddOrder_divider__ZK-gE","title":"AddOrder_title__1R-iB"};